<template>
  <div>
    <OtherHeader :img_header="header_image" header="แก้ไขคำถาม" link_back="faqspage"/>
    <Faqs_edit/>
  </div>
</template>

<script>
import OtherHeader from "@/components/admin/manage_website/other_setting/menu_other/OtherHeader";
import Faqs_edit from "@/components/admin/manage_website/other_setting/Faqs_edit";
import HeaderImage from "@/assets/faqs.png";
export default {
  name: "FaqsEdit",
  components: {
    Faqs_edit,
    OtherHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
